define(function(require) {
    'use strict';
    var AppConfig = require('config/application');
    var Backbone = require('backbone');
    var Model = require('models/messageTemplate');

    return Backbone.Collection.extend({
        url: AppConfig.host + '/rest/templates',
        model: Model
    });
});